export type SortOrder = 'acc' | 'dec';
export type PageSize = 5 | 10 | 15 | 25 | 'all';
export enum QueryNames {
  CUR_PAGE = 'curPage',
  PER_PAGE = 'perPage',
  SORTED = 'sorted',
}
